/** Người thân của bệnh nhân. Real /api/v1/patients/{id}/relations. */
import { apiClient } from "./client";

export type RelationshipCode =
  | "SPOUSE"
  | "CHILD"
  | "PARENT"
  | "SIBLING"
  | "GRANDPARENT"
  | "GRANDCHILD"
  | "OTHER";

export const RELATIONSHIP_LABEL: Record<RelationshipCode, string> = {
  SPOUSE: "Vợ/Chồng",
  CHILD: "Con",
  PARENT: "Cha/Mẹ",
  SIBLING: "Anh/Chị/Em",
  GRANDPARENT: "Ông/Bà",
  GRANDCHILD: "Cháu",
  OTHER: "Khác",
};

export interface Relative {
  relationId: string;
  relativePatientId: string;
  patientCode: string | null;
  fullName: string;
  phone: string | null;
  gender: string | null;
  dateOfBirth: string | null;
  relationship: RelationshipCode;
}

/** Chủ tài khoản đang giữ hồ sơ này làm người thân (chiều ngược của `Relative`). */
export interface Holder {
  relationId: string;
  patientId: string;
  patientCode: string | null;
  fullName: string;
  relationship: RelationshipCode;
}

export const patientRelationsApi = {
  list(patientId: string): Promise<Relative[]> {
    return apiClient
      .get<Relative[]>(`/v1/patients/${patientId}/relations`)
      .then((r) => r.data);
  },
  holders(patientId: string): Promise<Holder[]> {
    return apiClient
      .get<Holder[]>(`/v1/patients/${patientId}/relations/holders`)
      .then((r) => r.data);
  },
  add(
    patientId: string,
    relativePatientId: string,
    relationship: RelationshipCode
  ): Promise<string> {
    return apiClient
      .post<{ id: string }>(`/v1/patients/${patientId}/relations`, {
        relativePatientId,
        relationship,
      })
      .then((r) => r.data.id);
  },
  remove(patientId: string, relationId: string): Promise<void> {
    return apiClient
      .delete(`/v1/patients/${patientId}/relations/${relationId}`)
      .then(() => undefined);
  },
};

export const patientRelationQueryKeys = {
  list: (patientId: string) => ["patient-relations", patientId] as const,
  holders: (patientId: string) => ["patient-relations", patientId, "holders"] as const,
};
